<template>
	<div class="bg-vanilla">
		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
				{{ $t("navbar.news") }}
			</h1>
		</div>
		<div class="container py-4">
			<div class="row mb-3" v-if="!loader">
				<Item class="news__link col-12 col-lg-6 text-decoration-none" :id="set[0]" :linkHU="set[1].linkHU" :linkEN="set[1].linkEN" :titleHU="set[1].titleHU" :titleEN="set[1].titleEN" :introEN="set[1].introEN" :introHU="set[1].introHU" v-if="!loader" v-for="(set, index) in db" v-bind:key="index" :img="set[1].img" :lang="lang"></Item>
			</div>
			<div v-if="loader" class="col-12 text-center loading-container">
				<div class="loading-spinner"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";
	import firebase from "firebase/app";
	import Item from "./News_item";
	
	export default {
		components: {
		    Item
	  	},
		data: function () {
			return {
				lang: "",
				db: [],
				loader: true
			};
		},
		created: function () {
			this.lang = this.$i18n.locale;

			var self = this;
			var dbRef = firebase.database().ref('news/').orderByChild("date");

			dbRef.on('value', function(snapshot) {
			    snapshot.forEach(function(childSnapshot) {
				  	if(childSnapshot.val().visible === true){
				  		self.db.push([childSnapshot.key, childSnapshot.val()]);
				  	}
				});
			});

			this.db.reverse();
			this.loader = false;

		},
		mounted: function(){
			var self = this;
	    	Bus.$on("lang", (lang) => {
				if(lang === "hu"){
					self.lang = "hu";
				}else{
					self.lang = "en";
				}
			});
		},
		watch: {
		    lang: function () {
		      	if(this.lang === "hu"){
					history.pushState('', "Hírek", "https://ijaszat.eu/hirek");
				}else{
					history.pushState('', "News", "https://ijaszat.eu/news");
				}
			}
		},
		metaInfo() {
		    return {
				titleTemplate: chunk => (
					this.lang === 'hu'
                    ? 'Csodaszarvas Íjászbarlang - Híreink'
                    : 'Csodaszarvas Íjászbarlang - News'
				),
				meta: [
	    			{
	    				vmid: 'description',
				        name: 'description',
				        content: this.lang === 'hu' ? 'Aktuális híreink a boltról, íjakról, táborokról, egyesületi illetve versenyekkel kapcsolatos információkról.' : 'Our current news about the shop, bows, camps, information about associations and competitions.',
	    			},
	    			{
	    				vmid: 'og:description',
				        name: 'og:description',
				        content: this.lang === 'hu' ? 'Aktuális híreink a boltról, íjakról, táborokról, egyesületi illetve versenyekkel kapcsolatos információkról.' : 'Our current news about the shop, bows, camps, information about associations and competitions.',
	    			},
	    			{
	    				vmid: 'og:title',
	    				property: 'og:title',
	        			content: this.lang === 'hu' ? 'Csodaszarvas Íjászbarlang - Híreink' : 'Csodaszarvas Íjászbarlang - News',
	    			}
	    		]
			};
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/News.vue